<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Tài khoản học phí"
          :link="[
            { text: 'Nâng cao', href: '../divisions' },
            { text: 'Tài khoản học phí', href: '../school-bank-account' },
          ]"
        />
      </div>
      <div v-if="!schoolBankAccount.id && !loading && $auth.policies['config-school-bank-account']" class="flex-center">
        <v-btn @click="openDialog" dark color="#0D47A1"> Cấu hình khoản học phí</v-btn>
      </div>
    </div>
    <TableAccount
      :banks="banks"
      v-if="schoolBankAccount.id && !loading && $auth.policies['config-school-bank-account']"
    />
    <PopupAccount ref="popup-account" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import PopupAccount from '../../modules/school-bank-account/PopupAccount.vue'
import TableAccount from '../../modules/school-bank-account/TableAccount.vue'
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
export default {
  components: {
    Breadcrumbs,
    PopupAccount,
    TableAccount,
  },
  data() {
    return {
      loading: false,
      banks: [],
    }
  },
  computed: {
    ...mapState({
      schoolBankAccount: (state) => state.schoolBankAccount.schoolBankAccount,
    }),
  },
  async created() {
    try {
      this.loading = true
      const banks = await axios.get('https://api.vietqr.io/v2/banks')
      this.banks = banks.data
      await this.fetch()
    } catch (error) {
      this.$alert.warn('Vui lòng cấu hình tài khoản học phí')
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetch: 'schoolBankAccount/fetch',
    }),
    openDialog() {
      this.$refs['popup-account'].openDialog(null, this.banks)
    },
  },
}
</script>

<style></style>
